import { useEffect } from "react";
import Select from "../ui-components/Select";
import Button from "../ui-components/Button";
import { useState } from "react";
import SearchSelect from "@ui-components/SearchSelect";

const DEFAULT_OUTPUT_OBJ = {
  recursive_question_id: null,
  output_id: null,
}
const ServiceConfiguratorBlockCalculationRecursiveSumGenerator = ({
  updateRecursiveSumConfiguration,
  recursiveSumConfiguration,
  setSelectedOperator,
  questions,
  outputs,
  recursiveQuestions,
  editable=true,
}) => {
  const recursiveSumConfigurationObject = recursiveSumConfiguration === "recursive_sum"
    ? {...DEFAULT_OUTPUT_OBJ, original: recursiveSumConfiguration}
    : JSON.parse(recursiveSumConfiguration);

  const [chosenRecursiveQuestion, setChosenRecursiveQuestion] = useState(
    recursiveSumConfigurationObject.recursive_question_id? {
    label: recursiveQuestions.filter(q=>q.id===recursiveSumConfigurationObject.recursive_question_id)[0]?.name || `Question ${recursiveSumConfigurationObject.recursive_question_id}`,
    value: recursiveSumConfigurationObject.recursive_question_id
  }: null);
  const [chosenOutput, setChosenOutput] = useState(
    recursiveSumConfigurationObject.output_id? {
    label: outputs.filter(o=>o.id===recursiveSumConfigurationObject.output_id)[0]?.name || `Output ${recursiveSumConfigurationObject.output_id}`,
    value: recursiveSumConfigurationObject.output_id
  }: null);

  useEffect(() => {
    if (editable)
      updateRecursiveSumConfiguration(recursiveSumConfigurationObject)
  }, []);  // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="flex flex-col w-full mb-8 mt-8">
      <div className=" mb-2 flex text-center justify-center">
        <p className="font-bold">Recursive Sum configurator</p>
      </div>
      {recursiveQuestions?.length &&
        <SearchSelect
          label={"Select recursive question"}
          options={recursiveQuestions.map((q) => ({
            label: q.name || `Question ${q.id}`,
            value: q.id,
          }))}
          value = {chosenRecursiveQuestion}
          onChange={(e) => {
            setChosenRecursiveQuestion(e);
            updateRecursiveSumConfiguration({
              ...recursiveSumConfigurationObject,
              recursive_question_id: parseInt(e.value),
              output_id: outputs.filter(o=>o.recursive_question_id===parseInt(e.value))[0]?.id || null
            })
          }}
          isDisabled={!editable}
        />}
      {recursiveSumConfigurationObject.recursive_question_id &&
        <SearchSelect
          label={"Select output"}
          options={outputs.filter(o=>o.recursive_question_id===recursiveSumConfigurationObject.recursive_question_id).map((q) => ({
            label: q.name || `Output ${q.id}`,
            value: q.id,
          }))}
          isDisabled={!editable}
          value = {chosenOutput}
          onChange={(e) => {
            setChosenOutput(e);
            updateRecursiveSumConfiguration({
              ...recursiveSumConfigurationObject,
              output_id: parseInt(e.value)
            })
          }}
        />}
      {editable && <div className="mt-4 flex justify-end">
        <Button onClick={() => setSelectedOperator(null)}>DONE</Button>
      </div>}
    </div>

  )
}

export default ServiceConfiguratorBlockCalculationRecursiveSumGenerator;